import {
  parse_flight_offers_itinerary_carriers,
  parse_flight_offers_date,
  is_adult,
} from '@/utilities';
import { parse_fligth_offer_bags } from '@/flight-offer';
import { divide, max, multiply, round } from 'mathjs';

export const carrier_iata = (itinerary, segment_index = 0) => {
  const index = itinerary.segments.length < segment_index ? segment_index : 0;
  return parse_flight_offers_itinerary_carriers(itinerary.segments)[index];
};
export const get_day_delta = (departure, arrival) => {
  let date_departure = parse_flight_offers_date(departure).date,
    date_arrival = parse_flight_offers_date(arrival).date,
    delta = date_arrival.getTime() - date_departure.getTime();

  delta = round(divide(delta, multiply(1000, 3600, 24)), 0);
  return delta;
};

export const get_itinerary_delta = (itinerary) =>
  get_day_delta(
    itinerary.segments[0].departure.at,
    itinerary.segments[itinerary.segments.length - 1].arrival.at
  );

export const bags_quantity_color = (quantity, active_color = '#39414E') =>
  quantity > 0 ? active_color : '#AAAAAA';

export const hand_bags_per_adult = (flight_offer) => {
  if (!flight_offer) {
    return 0;
  }
  return (flight_offer.travelerPricings || []).length > 0 ? 1 : 0;
};
export const luggage_bags_per_adult = (flight_offer, itinerary_index = 0) => {
  if (!flight_offer) {
    return 0;
  }
  const { travelers = [] } = parse_fligth_offer_bags(flight_offer, itinerary_index);
  return travelers
    .filter((traveler) => is_adult(traveler))
    .reduce((included, traveler) => max(traveler.included || 0, included), 0);
};
